var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-filter", {
    attrs: {
      "status-options": _vm.statuses,
      "date-mode": "range",
      "show-team-members": true,
      "show-carriers": true,
      "show-customer-filter": true,
      "show-time-window": true,
      "show-driver-rating": true,
      "show-blank-date-toggle": true,
      clearable: false,
      "team-region-id": _vm.teamRegionId,
      "initial-filters": _vm.initialFilters,
      "status-test-id": "stop-status",
      "from-date-test-id": "start-date",
      "to-date-test-id": "end-date",
      "default-status": "Active",
      "time-window-filter-options": _vm.timeWindowFilterOptions,
      "is-geocoded-view": _vm.isGeocodedView,
      "blank-date-label": "Show stops with no date first",
      domain: "stops",
    },
    on: { onFilterStops: _vm.handleFilterStops },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }